/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_vendor_aws': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-2-2h24v24H-2z"/><g _fill="#FF9901"><path pid="1" d="M0 5l9 3v12l-9-3zM20 5l-9 3v12l9-3zM1.5 3.398L10 6.5l8.5-3.102L10 .5z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_vendor_aws.js